import styled, { css } from 'styled-components';

export const ProductList = styled.div`
  ${({ theme, ...props }) => {
    return css`
      display: flex;
      flex-direction: column;
      gap: 1rem;
      margin-top: 1rem;

      @media screen and (min-width: ${theme.breakpoint.md}) and (max-width: ${theme.breakpoint.lg}) {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-row-start: span;
        > div {
          justify-content: space-between;
        }
      }
    `;
  }};
`;
